import React from 'react';
import { Dropdown, Space } from 'antd';
import { useModalState } from '../../../hooks/modalState';
import {
    TagActionsButtonContainer,
    TagMenu,
    TagActionsButton
} from './TagActions.styles';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import DeleteModal from '../deleteModal/DeleteModal';
import ChangeColorModal from '../changeColorModal/ChangeColorModal';
import { useAppSelector } from '../../../hooks/redux';
import { Color } from '../../../redux/actions/colorsActions/types';
import { grayDark10 } from '../../../styles/colors';
enum TagAction {
    Delete = 'delete',
    ChangeColor = 'changeColor',
}

interface Props {
    selectedCount: number;
    selectedTagNames: string[];
    onBulkDelete: () => void;
    onBulkChangeColor: (color: Color) => void;
    disabled?: boolean;
}

const TagActions: React.FC<Props> = ({
    selectedCount,
    selectedTagNames,
    onBulkDelete,
    onBulkChangeColor,
    disabled,
}) => {
    const actionDropdown = useModalState();
    const deleteModal = useModalState();
    const changeColorModal = useModalState();

    const { pending } = useAppSelector((state) => state.tagReducer);

    const handleMenuSelect = (data: { key: string }) => {
        switch (data.key) {
            case TagAction.Delete:
                if (selectedCount > 0) {
                    deleteModal.onOpen();
                }
                break;
            case TagAction.ChangeColor:
                if (selectedCount > 0) {
                    changeColorModal.onOpen();
                }
                break;
            default:
                break;
        }
    };

    const handleDeleteReload = () => {
        onBulkDelete();
        deleteModal.onClose();
        actionDropdown.onClose();
    };

    const handleDeleteClose = () => {
        actionDropdown.onClose();
        deleteModal.onClose();
    };

    const handleChangeColorClose = () => {
        actionDropdown.onClose();
        changeColorModal.onClose();
    };
    const tagActions = [
        {
            key: TagAction.ChangeColor,
            label: 'Change color',
        },
        {
            type: 'divider',
            style: { backgroundColor: grayDark10 },
        },
        {
            key: TagAction.Delete,
            label: 'Delete selected',
        },
    ];

    return (
        <div style={{ alignSelf: 'flex-end' }}>
            <Space>
                <Dropdown
                    menu={{
                        items: tagActions,
                        onClick: handleMenuSelect,
                        style: { top: -36 },
                    }}
                    placement="bottom"
                    trigger={['click']}
                    onOpenChange={(open) => (open ? actionDropdown.onOpen() : actionDropdown.onClose())}
                    disabled={disabled}
                >
                    <TagActionsButtonContainer>
                        <TagActionsButton id="tag-actions-button" disabled={disabled}>Actions</TagActionsButton>
                        <TagMenu id="tag-actions-menu" disabled={disabled}>
                            {actionDropdown.isOpen ? (
                                <CaretUpOutlined style={{ color: 'white' }} />
                            ) : (
                                <CaretDownOutlined style={{ color: 'white' }} />
                            )}
                        </TagMenu>
                    </TagActionsButtonContainer>
                </Dropdown>
            </Space>

            <DeleteModal
                isOpen={deleteModal.isOpen}
                closeModal={handleDeleteClose}
                reload={handleDeleteReload}
                title="tag"
                text={`${selectedCount} selected tag(s)`}
                pending={pending}
                icon='tag-delete.svg'
                itemList={selectedTagNames}
            />

            <ChangeColorModal
                isOpen={changeColorModal.isOpen}
                closeModal={handleChangeColorClose}
                onSubmit={onBulkChangeColor}
                tagNames={selectedTagNames}
                pending={pending}
            />
        </div>
    );
};

export default TagActions;
